/**
 * Styled Components - Created by gustavomedina on 04/05/18.
 */
import styled from 'styled-components'
import Popover from 'antd/lib/popover'
import { GREEN, GRAY, BLUE, FACEBOOKBLUE, RED, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

type StyleProps = {
  onlyRead?: boolean
  secondary?: boolean
}

export const Container = styled.li`
  list-style-type: none;
  display: flex;
  flex-direction: row;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
  background: ${({ secondary }: StyleProps) => secondary ? '#f8f6ff' : 'auto'};
  @media (max-width: 640px) {
    flex-direction: column;
    margin-bottom: 40px;
    padding: 3px 3px;
  }
`

export const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: row;
    position: relative;
  }
`

export const UpsLabel = styled.div`
  font-size: 12px;
  background: #f9f8e5;
  width: fit-content;
  padding: 3px 12px;
  border-radius: 25px;
  margin-top: -16px;
  margin-left: 18px;
  display: flex;
  align-items: center;
  padding-left: 0;
  @media (max-width: 640px) {
    margin-top: 8px;
    margin-left: 4px;
    margin-bottom: -10px;
  }
`

export const UpsIcon = styled.img`
  max-width: 19px;
  border-radius: 25px;
  padding: 0px;
  margin-top: -3px;
  margin-bottom: -2px;
  margin-right: 6px;
  margin-left: -3px;
`

export const UspsIcon = styled.img`
  max-width: 30px;
  margin-top: -9px;
  margin-bottom: -8px;
  margin-right: 6px;
  margin-left: 6px;
`

export const TrackingLink = styled.a`
  color: #3887e3;
  margin-left: 4px;
  text-decoration: underline;
`

export const ItemDetailsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    justify-content: space-around;
  }
`

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ItemDetailsHeaderName = styled.div`
  color: #5f6062;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  text-transform: uppercase;
  @media(max-width: 767px) {
    font-size: 14px;
  }
  @media(max-width: 480px) {
    font-size: 13px;
  }
  @media(max-width: 380px) {
    font-size: 12px;
  }
`

export const ItemDetailsHeaderNameDetail = styled.div`
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
  @media(max-width: 767px) {
    font-size: 13px;
  }
  @media(max-width: 480px) {
    font-size: 12px;
  }
  @media(max-width: 380px) {
    font-size: 11px;
  }
`

export const ItemDetailsHeaderPrice = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: right;

  @media (max-width: 640px) {
    text-align: left;
  }
`

interface ItemDetailsHeaderProps {
  highlighted?: boolean
  color?: string
}

export const ItemDetailsHeaderPriceDetail = styled.div`
  color: ${({ highlighted, color }: ItemDetailsHeaderProps) =>
    highlighted ? GREEN : (color || GRAY)};
  font-size: 12px;
  letter-spacing: 0.13px;
  line-height: 14px;
  text-align: right;

  @media (max-width: 640px) {
    text-align: left;
  }
`

export const HeaderPriceDetailEmpty = styled.div`
  height: 14px;
`

export const ItemDetailsContent = styled.div``

export const Image = styled.img`
  object-fit: cover;
  user-select: none;
  height: 180.29px;
  width: 160.44px;
  border-radius: 3px;
  background-color: #f1f4f5;
  box-shadow: 1px 1px 4px -1px #cdcdcd;
  &:hover {
    cursor: pointer;
  }
  @media only screen and (max-width: 640px) {
    height: 129px;
    width: 100%;
    max-width: 196px;
    margin: 0;
    object-fit: cover;
  }
`

export const FooterItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 640px) {
    margin-top: 12px;
  }
`

export const AddMore = styled.div`
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  cursor: pointer;
  padding-right: 16px;
`

export const DeleteItem = styled.div`
  margin-top: 20px;
  color: #e61737;
  font-size: 12px;
  letter-spacing: 0.09px;
  line-height: 16px;
  cursor: pointer;
  padding-right: 16px;

  @media (max-width: 640px) {
    margin-top: 1em;
  }
`

export const BottomDivider = styled.div`
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  background-color: #dcdcdc;
  margin-right: 16px;
  margin-bottom: 30px;
  @media (max-width: 698px) {
    margin-bottom: 10px;
    display: none;
  }
`

export const FromTeamStore = styled.div`
  margin-bottom: 10px;
`

export const StoreLink = styled.div`
  display: inline-block;
  text-decoration: underline;
  color: ${BLUE};
  cursor: pointer;
  transition: all .25s;
  &:hover {
    color: ${FACEBOOKBLUE};
  }
`

export const TestPrintIcon = styled.img`
  max-width: 22px;
  position: absolute;
  left: 12px;
  z-index: 3;
  bottom: ${({ onlyRead }: StyleProps) => onlyRead ? '10px' : '50px'};
  @media (max-width: 640px) {
    bottom: 10px;
  }
`

export const ImageContainer = styled.div`
  position: relative;
  @media only screen and (max-width: 640px) {
    width: 46%;
  }
`

export const StatusFlag = styled.img`
  position: absolute;
  height: 50px;
  right: 5px;
  top: 5px;
  z-index: 8;
  @media (max-width: 640px) {
    height: 32px;
  }
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 398px;
`

export const TooltipContentModal = styled.div`
  max-width: 398px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const StatusIcon = styled.img`
  float: right;
  max-width: 78px;
  margin-left: 8px;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const buttonStyle = {
  boxShadow: 'none',
  border: 'none',
  background: 'none',
  color: RED
}

export const TicketDiv = styled.div`
  font-size: 11px;
  display: flex;
  padding-left: 16px;
  flex-flow: column-reverse;
  align-items: flex-start;
`

export const TicketLink = styled.a`
  font-size: 14px;
  margin-bottom: 2px;
  color: ${BLUE};
`

export const TestPrintDiv = styled.div`
  position: absolute;
  left: 8px;
  z-index: 3;
  bottom: ${({ onlyRead }: StyleProps) => onlyRead ? '5px' : '50px'};
  @media (max-width: 640px) {
    bottom: 10px;
  }
`

export const PlusSign = styled(Icon)`
  position: absolute;
  right: -3px;
  top: -3px;
  font-size: 10px;
  filter: brightness(1.2);
  z-index: 2;
`

export const PrintIcon = styled.img`
  max-width: 26px;
  object-fit: contain;
  opacity: 0.7;
  background: ${WHITE};
  padding: 4px;
  border-radius: 25px;
  border-bottom-left-radius: 0px;
`

export const CircleIcon = styled(Icon)`
  max-width: 26px;
  object-fit: contain;
  opacity: 0.8;
  background: ${WHITE};
  padding: 4px;
  border-radius: 25px;
  border-bottom-left-radius: 0px;
`

export const NotesDiv = styled.div`
  color: #736b99;
  font-size: 13px;
`

export const NotesTitle = styled.div`
  font-weight: bold;
  color: #7e789c;
`

export const EditIcon = styled(Icon)`
  transition: all .25s;
  margin-right: 6px;
  color: rebeccapurple;
  transition: all .25s;
`

export const NotesDivMobile = styled.div`
  margin-left: 18px;
  margin-top: 10px;
  color: #8a80bc;
  font-size: 13px;
  display: none;
  @media (max-width: 640px) {
    display: flex;
    margin: 0;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartListItem/styledComponents.tsx